module.exports = __webpack_public_path__ + "static/media/close.9f9d6d57.png";